import { jsx as _jsx } from 'react/jsx-runtime.js';
import { SocialGoogleButton } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { googleAuthUrl } from '../../../redux/features/google/service/index.js';
import { useAppSelector } from '../../../redux/hooks.js';
import { isGoogleEnabledSelector, currentLocaleSelector, } from '../../../redux/core/siteConfig/siteConfigSlice.js';
import { loginSourceSelector, redirectionUrlSelector, } from '../../../redux/core/sourceData/sourceDataSlice.js';
import { useCurrentUrl } from '../../../helpers/url/useCurrentUrl.js';
import { rememberMeSelector } from '../../../views/Login/loginSlice.js';
import { buildGoogleOverwritedRedirectionUrl } from '../../../redux/features/google/buildGoogleOverwritedRedirectionUrl.js';
import { useTrack } from '../../../tracking/common/hooks/useTrack.js';
import { activeWrapperSelector } from '../../../redux/core/wrapperContext/wrapperContextSlice.js';
export const LoginWithGoogle = () => {
    const { t } = useTranslation();
    const redirectionUrl = useAppSelector(redirectionUrlSelector);
    const loginSource = useAppSelector(loginSourceSelector);
    const currentLocale = useAppSelector(currentLocaleSelector);
    const currentUrl = useCurrentUrl();
    const checkboxState = useAppSelector(rememberMeSelector);
    const activeWrapper = useAppSelector(activeWrapperSelector);
    const overwritedRedirectionUrl = buildGoogleOverwritedRedirectionUrl(activeWrapper, redirectionUrl, currentUrl);
    const { trackBtnClick } = useTrack('standard');
    const onGoogleButtonClick = () => {
        trackBtnClick({ uniqueName: 'loginWithGoogle' });
    };
    const isGoogleEnable = useAppSelector(isGoogleEnabledSelector);
    return isGoogleEnable ? (_jsx(SocialGoogleButton, { "data-testid": "google-login-btn", "data-dd-action-name": "rla_forms_standard_googleClick", as: "a", a11yLabel: "Login with google button", href: googleAuthUrl({
            redirectionUrl: overwritedRedirectionUrl,
            loginSource,
            currentLocale,
            checkboxState,
            currentUrl,
            formType: 'login',
        }), isFullWidth: true, size: ['medium'], onClick: onGoogleButtonClick, children: t('loginregistration.login.googleButton') })) : null;
};
//# sourceMappingURL=LoginWithGoogle.js.map